'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { useAuth } from '@/providers/auth-provider';
type AuthenticatedFeaturesProps = {
  children: ReactNode;
};

/**
 * A component that only renders its children when the user is authenticated.
 * This is used to prevent authentication-dependent components from loading
 * on public routes when the user is not logged in.
 */
export function AuthenticatedFeatures(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  const {
    isAuthenticated
  } = useAuth();
  if (!isAuthenticated) {
    return null;
  }
  let t1;
  if ($[0] !== children) {
    t1 = <>{children}</>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}